module.exports = SHIYUQI_RANKING = [
{"date": "2013-11-14", "worldRanking": 806},
{"date": "2013-11-21", "worldRanking": 821},
{"date": "2013-11-28", "worldRanking": 826},
{"date": "2013-12-05", "worldRanking": 822},
{"date": "2013-12-12", "worldRanking": 495},
{"date": "2013-12-19", "worldRanking": 503},
{"date": "2013-12-26", "worldRanking": 497},
{"date": "2014-01-02", "worldRanking": 497},
{"date": "2014-01-09", "worldRanking": 497},
{"date": "2014-01-16", "worldRanking": 500},
{"date": "2014-01-23", "worldRanking": 499},
{"date": "2014-01-30", "worldRanking": 506},
{"date": "2014-02-06", "worldRanking": 506},
{"date": "2014-02-13", "worldRanking": 506},
{"date": "2014-02-20", "worldRanking": 532},
{"date": "2014-02-27", "worldRanking": 533},
{"date": "2014-03-06", "worldRanking": 532},
{"date": "2014-03-13", "worldRanking": 524},
{"date": "2014-03-20", "worldRanking": 521},
{"date": "2014-03-27", "worldRanking": 521},
{"date": "2014-04-03", "worldRanking": 525},
{"date": "2014-04-10", "worldRanking": 520},
{"date": "2014-04-17", "worldRanking": 516},
{"date": "2014-04-24", "worldRanking": 527},
{"date": "2014-05-02", "worldRanking": 529},
{"date": "2014-05-08", "worldRanking": 527},
{"date": "2014-05-15", "worldRanking": 526},
{"date": "2014-05-22", "worldRanking": 523},
{"date": "2014-05-29", "worldRanking": 525},
{"date": "2014-06-05", "worldRanking": 524},
{"date": "2014-06-12", "worldRanking": 532},
{"date": "2014-06-19", "worldRanking": 534},
{"date": "2014-06-26", "worldRanking": 536},
{"date": "2014-07-03", "worldRanking": 530},
{"date": "2014-07-10", "worldRanking": 525},
{"date": "2014-07-17", "worldRanking": 521},
{"date": "2014-07-24", "worldRanking": 346},
{"date": "2014-07-31", "worldRanking": 347},
{"date": "2014-08-07", "worldRanking": 347},
{"date": "2014-08-14", "worldRanking": 348},
{"date": "2014-08-21", "worldRanking": 352},
{"date": "2014-08-28", "worldRanking": 352},
{"date": "2014-09-04", "worldRanking": 352},
{"date": "2014-09-11", "worldRanking": 440},
{"date": "2014-09-18", "worldRanking": 441},
{"date": "2014-09-25", "worldRanking": 445},
{"date": "2014-10-02", "worldRanking": 449},
{"date": "2014-10-09", "worldRanking": 448},
{"date": "2014-10-16", "worldRanking": 442},
{"date": "2014-10-23", "worldRanking": 442},
{"date": "2014-10-30", "worldRanking": 441},
{"date": "2014-11-06", "worldRanking": 447},
{"date": "2014-11-13", "worldRanking": 542},
{"date": "2014-11-20", "worldRanking": 409},
{"date": "2014-11-27", "worldRanking": 409},
{"date": "2014-12-04", "worldRanking": 300},
{"date": "2014-12-11", "worldRanking": 300},
{"date": "2014-12-18", "worldRanking": 302},
{"date": "2014-12-24", "worldRanking": 303},
{"date": "2015-01-02", "worldRanking": 303},
{"date": "2015-01-08", "worldRanking": 303},
{"date": "2015-01-15", "worldRanking": 309},
{"date": "2015-01-22", "worldRanking": 305},
{"date": "2015-01-29", "worldRanking": 309},
{"date": "2015-02-05", "worldRanking": 312},
{"date": "2015-02-12", "worldRanking": 312},
{"date": "2015-02-18", "worldRanking": 309},
{"date": "2015-02-26", "worldRanking": 311},
{"date": "2015-03-05", "worldRanking": 311},
{"date": "2015-03-12", "worldRanking": 310},
{"date": "2015-03-19", "worldRanking": 311},
{"date": "2015-03-26", "worldRanking": 307},
{"date": "2015-04-02", "worldRanking": 308},
{"date": "2015-04-09", "worldRanking": 309},
{"date": "2015-04-16", "worldRanking": 307},
{"date": "2015-04-23", "worldRanking": 307},
{"date": "2015-04-30", "worldRanking": 300},
{"date": "2015-05-07", "worldRanking": 306},
{"date": "2015-05-14", "worldRanking": 308},
{"date": "2015-05-21", "worldRanking": 308},
{"date": "2015-05-28", "worldRanking": 305},
{"date": "2015-06-04", "worldRanking": 306},
{"date": "2015-06-11", "worldRanking": 304},
{"date": "2015-06-18", "worldRanking": 304},
{"date": "2015-06-25", "worldRanking": 275},
{"date": "2015-07-02", "worldRanking": 239},
{"date": "2015-07-09", "worldRanking": 241},
{"date": "2015-07-16", "worldRanking": 241},
{"date": "2015-07-23", "worldRanking": 287},
{"date": "2015-07-30", "worldRanking": 287},
{"date": "2015-08-06", "worldRanking": 287},
{"date": "2015-08-13", "worldRanking": 284},
{"date": "2015-08-20", "worldRanking": 280},
{"date": "2015-08-27", "worldRanking": 283},
{"date": "2015-09-03", "worldRanking": 286},
{"date": "2015-09-10", "worldRanking": 290},
{"date": "2015-09-17", "worldRanking": 289},
{"date": "2015-09-23", "worldRanking": 291},
{"date": "2015-10-01", "worldRanking": 289},
{"date": "2015-10-08", "worldRanking": 227},
{"date": "2015-10-15", "worldRanking": 226},
{"date": "2015-10-22", "worldRanking": 226},
{"date": "2015-10-29", "worldRanking": 223},
{"date": "2015-11-05", "worldRanking": 222},
{"date": "2015-11-12", "worldRanking": 173},
{"date": "2015-11-19", "worldRanking": 122},
{"date": "2015-11-26", "worldRanking": 121},
{"date": "2015-12-03", "worldRanking": 135},
{"date": "2015-12-10", "worldRanking": 113},
{"date": "2015-12-17", "worldRanking": 113},
{"date": "2015-12-23", "worldRanking": 115},
{"date": "2015-12-31", "worldRanking": 115},
{"date": "2016-01-07", "worldRanking": 115},
{"date": "2016-01-14", "worldRanking": 115},
{"date": "2016-01-21", "worldRanking": 114},
{"date": "2016-01-28", "worldRanking": 108},
{"date": "2016-02-04", "worldRanking": 76},
{"date": "2016-02-11", "worldRanking": 76},
{"date": "2016-02-18", "worldRanking": 77},
{"date": "2016-02-25", "worldRanking": 66},
{"date": "2016-03-03", "worldRanking": 67},
{"date": "2016-03-10", "worldRanking": 65},
{"date": "2016-03-17", "worldRanking": 64},
{"date": "2016-03-24", "worldRanking": 66},
{"date": "2016-03-31", "worldRanking": 51},
{"date": "2016-04-07", "worldRanking": 51},
{"date": "2016-04-14", "worldRanking": 51},
{"date": "2016-04-21", "worldRanking": 51},
{"date": "2016-04-28", "worldRanking": 45},
{"date": "2016-05-05", "worldRanking": 45},
{"date": "2016-05-12", "worldRanking": 45},
{"date": "2016-05-19", "worldRanking": 45},
{"date": "2016-05-26", "worldRanking": 45},
{"date": "2016-06-02", "worldRanking": 45},
{"date": "2016-06-09", "worldRanking": 43},
{"date": "2016-06-16", "worldRanking": 43},
{"date": "2016-06-23", "worldRanking": 45},
{"date": "2016-06-30", "worldRanking": 42},
{"date": "2016-07-08", "worldRanking": 42},
{"date": "2016-07-14", "worldRanking": 42},
{"date": "2016-07-21", "worldRanking": 42},
{"date": "2016-07-28", "worldRanking": 42},
{"date": "2016-08-04", "worldRanking": 41},
{"date": "2016-08-11", "worldRanking": 41},
{"date": "2016-08-18", "worldRanking": 41},
{"date": "2016-08-25", "worldRanking": 41},
{"date": "2016-09-01", "worldRanking": 41},
{"date": "2016-09-08", "worldRanking": 41},
{"date": "2016-09-15", "worldRanking": 32},
{"date": "2016-09-22", "worldRanking": 32},
{"date": "2016-09-29", "worldRanking": 21},
{"date": "2016-10-06", "worldRanking": 23},
{"date": "2016-10-13", "worldRanking": 25},
{"date": "2016-10-20", "worldRanking": 24},
{"date": "2016-10-27", "worldRanking": 19},
{"date": "2016-11-03", "worldRanking": 16},
{"date": "2016-11-10", "worldRanking": 10},
{"date": "2016-11-17", "worldRanking": 9},
{"date": "2016-11-24", "worldRanking": 9},
{"date": "2016-12-01", "worldRanking": 10},
{"date": "2016-12-08", "worldRanking": 10},
{"date": "2016-12-15", "worldRanking": 10},
{"date": "2016-12-22", "worldRanking": 10},
{"date": "2016-12-29", "worldRanking": 10},
{"date": "2017-01-05", "worldRanking": 10},
{"date": "2017-01-12", "worldRanking": 10},
{"date": "2017-01-19", "worldRanking": 10},
{"date": "2017-01-26", "worldRanking": 11},
{"date": "2017-02-02", "worldRanking": 13},
{"date": "2017-02-10", "worldRanking": 13},
{"date": "2017-02-16", "worldRanking": 12},
{"date": "2017-02-23", "worldRanking": 10},
{"date": "2017-03-02", "worldRanking": 10},
{"date": "2017-03-09", "worldRanking": 10},
{"date": "2017-03-16", "worldRanking": 8},
{"date": "2017-03-23", "worldRanking": 7},
{"date": "2017-03-30", "worldRanking": 8},
{"date": "2017-04-06", "worldRanking": 9},
{"date": "2017-04-13", "worldRanking": 8},
{"date": "2017-04-20", "worldRanking": 6},
{"date": "2017-04-27", "worldRanking": 5},
{"date": "2017-05-04", "worldRanking": 5},
{"date": "2017-05-11", "worldRanking": 5},
{"date": "2017-05-18", "worldRanking": 5},
{"date": "2017-05-25", "worldRanking": 4},
{"date": "2017-06-01", "worldRanking": 4},
{"date": "2017-06-08", "worldRanking": 4},
{"date": "2017-06-15", "worldRanking": 4},
{"date": "2017-06-22", "worldRanking": 4},
{"date": "2017-06-29", "worldRanking": 4},
{"date": "2017-07-06", "worldRanking": 4},
{"date": "2017-07-13", "worldRanking": 4},
{"date": "2017-07-20", "worldRanking": 4},
{"date": "2017-07-27", "worldRanking": 4},
{"date": "2017-08-03", "worldRanking": 4},
{"date": "2017-08-10", "worldRanking": 4},
{"date": "2017-08-17", "worldRanking": 4},
{"date": "2017-08-24", "worldRanking": 2},
{"date": "2017-08-30", "worldRanking": 3},
{"date": "2017-09-07", "worldRanking": 3},
{"date": "2017-09-14", "worldRanking": 4},
{"date": "2017-09-21", "worldRanking": 4},
{"date": "2017-09-28", "worldRanking": 4},
{"date": "2017-10-05", "worldRanking": 4},
{"date": "2017-10-12", "worldRanking": 4},
{"date": "2017-10-19", "worldRanking": 4},
{"date": "2017-10-26", "worldRanking": 6},
{"date": "2017-11-02", "worldRanking": 7},
{"date": "2017-11-09", "worldRanking": 8},
{"date": "2017-11-16", "worldRanking": 8},
{"date": "2017-11-23", "worldRanking": 8},
{"date": "2017-11-30", "worldRanking": 8},
{"date": "2017-12-07", "worldRanking": 8},
{"date": "2017-12-14", "worldRanking": 8},
{"date": "2017-12-21", "worldRanking": 8},
{"date": "2017-12-28", "worldRanking": 8},
{"date": "2018-01-04", "worldRanking": 8},
{"date": "2018-01-11", "worldRanking": 8},
{"date": "2018-01-18", "worldRanking": 8},
{"date": "2018-01-25", "worldRanking": 8},
{"date": "2018-02-02", "worldRanking": 8},
{"date": "2018-02-08", "worldRanking": 7, "worldTourRanking": 13},
{"date": "2018-02-15", "worldRanking": 7},
{"date": "2018-02-22", "worldRanking": 7},
{"date": "2018-03-01", "worldRanking": 6, "worldTourRanking": 16},
{"date": "2018-03-08", "worldRanking": 6},
{"date": "2018-03-15", "worldRanking": 6, "worldTourRanking": 8},
{"date": "2018-03-22", "worldRanking": 5, "worldTourRanking": 2},
{"date": "2018-03-29", "worldRanking": 5},
{"date": "2018-04-05", "worldRanking": 5, "worldTourRanking": 2},
{"date": "2018-04-12", "worldRanking": 5},
{"date": "2018-04-19", "worldRanking": 4, "worldTourRanking": 2},
{"date": "2018-04-26", "worldRanking": 4},
{"date": "2018-05-03", "worldRanking": 5},
{"date": "2018-05-10", "worldRanking": 5, "worldTourRanking": 2},
{"date": "2018-05-17", "worldRanking": 3, "worldTourRanking": 3},
{"date": "2018-05-24", "worldRanking": 3},
{"date": "2018-05-31", "worldRanking": 3},
{"date": "2018-06-07", "worldRanking": 3},
{"date": "2018-06-14", "worldRanking": 3},
{"date": "2018-06-21", "worldRanking": 3, "worldTourRanking": 4},
{"date": "2018-06-28", "worldRanking": 3, "worldTourRanking": 4},
{"date": "2018-07-05", "worldRanking": 3, "worldTourRanking": 3},
{"date": "2018-07-12", "worldRanking": 3, "worldTourRanking": 2},
{"date": "2018-07-19", "worldRanking": 3, "worldTourRanking": 3},
{"date": "2018-07-26", "worldRanking": 3, "worldTourRanking": 4},
{"date": "2018-08-02", "worldRanking": 3, "worldTourRanking": 4},
{"date": "2018-08-09", "worldRanking": 2},
{"date": "2018-08-16", "worldRanking": 2, "worldTourRanking": 4},
{"date": "2018-08-23", "worldRanking": 2},
{"date": "2018-08-30", "worldRanking": 2},
{"date": "2018-09-06", "worldRanking": 2, "worldTourRanking": 4},
{"date": "2018-09-13", "worldRanking": 2, "worldTourRanking": 5},
{"date": "2018-09-20", "worldRanking": 3, "worldTourRanking": 6},
{"date": "2018-09-27", "worldRanking": 2, "worldTourRanking": 4},
{"date": "2018-10-04", "worldRanking": 2, "worldTourRanking": 5},
{"date": "2018-10-11", "worldRanking": 2, "worldTourRanking": 5},
{"date": "2018-10-18", "worldRanking": 2, "worldTourRanking": 5},
{"date": "2018-10-25", "worldRanking": 2, "worldTourRanking": 6},
{"date": "2018-11-01", "worldRanking": 2, "worldTourRanking": 4},
{"date": "2018-11-08", "worldRanking": 2, "worldTourRanking": 4},
{"date": "2018-11-15", "worldRanking": 2, "worldTourRanking": 4},
{"date": "2018-11-22", "worldRanking": 2, "worldTourRanking": 4},
{"date": "2018-11-29", "worldRanking": 2, "worldTourRanking": 4},
{"date": "2018-12-06", "worldRanking": 2},
{"date": "2018-12-13", "worldRanking": 2},
{"date": "2018-12-20", "worldRanking": 2},
{"date": "2018-12-27", "worldRanking": 2},
{"date": "2019-01-02", "worldRanking": 2},
{"date": "2019-01-08", "worldRanking": 2},
{"date": "2019-01-15", "worldRanking": 2},
{"date": "2019-01-22", "worldRanking": 2, "worldTourRanking": 13},
{"date": "2019-01-29", "worldRanking": 2, "worldTourRanking": 11},
{"date": "2019-02-05", "worldRanking": 2},
{"date": "2019-02-12", "worldRanking": 2},
{"date": "2019-02-19", "worldRanking": 2},
{"date": "2019-02-26", "worldRanking": 2, "worldTourRanking": 15},
{"date": "2019-03-05", "worldRanking": 2, "worldTourRanking": 26},
{"date": "2019-03-12", "worldRanking": 2, "worldTourRanking": 8},
{"date": "2019-03-19", "worldRanking": 2, "worldTourRanking": 3},
{"date": "2019-03-26", "worldRanking": 2, "worldTourRanking": 3},
{"date": "2019-04-02", "worldRanking": 2, "worldTourRanking": 4},
{"date": "2019-04-09", "worldRanking": 2, "worldTourRanking": 3},
{"date": "2019-04-16", "worldRanking": 2, "worldTourRanking": 5},
{"date": "2019-04-23", "worldRanking": 2},
{"date": "2019-04-30", "worldRanking": 2},
{"date": "2019-05-07", "worldRanking": 2, "worldTourRanking": 8},
{"date": "2019-05-14", "worldRanking": 2},
{"date": "2019-05-21", "worldRanking": 2},
{"date": "2019-05-28", "worldRanking": 2},
{"date": "2019-06-04", "worldRanking": 2},
{"date": "2019-06-11", "worldRanking": 2, "worldTourRanking": 9},
{"date": "2019-06-18", "worldRanking": 2},
{"date": "2019-06-25", "worldRanking": 2},
{"date": "2019-07-02", "worldRanking": 2},
{"date": "2019-07-09", "worldRanking": 2, "worldTourRanking": 9},
{"date": "2019-07-16", "worldRanking": 2, "worldTourRanking": 10},
{"date": "2019-07-23", "worldRanking": 2, "worldTourRanking": 12},
{"date": "2019-07-30", "worldRanking": 2, "worldTourRanking": 15},
{"date": "2019-08-06", "worldRanking": 3, "worldTourRanking": 20},
{"date": "2019-08-13", "worldRanking": 3, "worldTourRanking": 20},
{"date": "2019-08-20", "worldRanking": 3, "worldTourRanking": 20},
{"date": "2019-08-27", "worldRanking": 3},
{"date": "2019-09-03", "worldRanking": 3},
{"date": "2019-09-10", "worldRanking": 3, "worldTourRanking": 21},
{"date": "2019-09-17", "worldRanking": 3, "worldTourRanking": 21},
{"date": "2019-09-24", "worldRanking": 3, "worldTourRanking": 21},
{"date": "2019-10-01", "worldRanking": 3, "worldTourRanking": 24},
{"date": "2019-10-08", "worldRanking": 3, "worldTourRanking": 24},
{"date": "2019-10-15", "worldRanking": 3, "worldTourRanking": 24},
{"date": "2019-10-22", "worldRanking": 3, "worldTourRanking": 27},
{"date": "2019-10-29", "worldRanking": 6, "worldTourRanking": 30},
{"date": "2019-11-05", "worldRanking": 4, "worldTourRanking": 22},
{"date": "2019-11-12", "worldRanking": 7, "worldTourRanking": 23},
{"date": "2019-11-19", "worldRanking": 7, "worldTourRanking": 23},
{"date": "2019-11-26", "worldRanking": 7, "worldTourRanking": 23},
{"date": "2019-12-03", "worldRanking": 7},
{"date": "2019-12-10", "worldRanking": 7},
{"date": "2019-12-17", "worldRanking": 8},
{"date": "2019-12-24", "worldRanking": 8},
{"date": "2019-12-31", "worldRanking": 8},
{"date": "2020-01-07", "worldRanking": 8},
{"date": "2020-01-14", "worldRanking": 9, "worldTourRanking": 5},
{"date": "2020-01-21", "worldRanking": 8, "worldTourRanking": 3},
{"date": "2020-01-28", "worldRanking": 8, "worldTourRanking": 2},
{"date": "2020-02-04", "worldRanking": 8},
{"date": "2020-02-11", "worldRanking": 8},
{"date": "2020-02-18", "worldRanking": 8},
{"date": "2020-02-25", "worldRanking": 8, "worldTourRanking": 4},
{"date": "2020-03-03", "worldRanking": 8},
{"date": "2020-03-10", "worldRanking": 9},
{"date": "2020-03-17", "worldRanking": 9, "worldTourRanking": 3}
]



//////////////////
// WEBPACK FOOTER
// ./static/js/shiyuqi-ranking.js
// module id = 43lL
// module chunks = 1